export default {
  ACTIVITY: 'Aktivitet',
  ACTIVITY_NAVIGATION_PREV: 'Førre',
  ACTIVITY_NAVIGATION_NEXT: 'Neste',
  ACTIVITY_NAVIGATION_CONTINUE: 'Fortsette',
  ACTIVITY_NAVIGATION_FINISH: 'Ferdig',
}
